module.exports = __webpack_public_path__ + "static/media/gallery-logo.7308a0fa.svg";